<template>
  <div class="person-proof">
    <div class="person-proof-form">
      <span class="form-title">个人完税证明</span>
      <el-form ref="form" label-width="130px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input placeholder="请输入企业名称" v-model="form.enterpriseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="invoiceApplyStatus">
              <el-select v-model="form.invoiceApplyStatus">
                <el-option v-for="(item, index) in applyStatusAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="时间" prop="time">
              <el-date-picker v-model="form.time" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item style="margin-bottom: 0px; text-align: right;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="generateTax()">生成上月完税证明</el-button>
    </div>
    <el-table>
      <el-table-column prop="invoiceApplyNo" label="时间" width="150"> </el-table-column>
      <el-table-column prop="invoiceClass" label="企业名称"> </el-table-column>
      <el-table-column prop="invoiceApplyStatus" label="完税证明"> </el-table-column>
      <el-table-column prop="applyTime" label="最近上传时间"> </el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="物流单号" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="=状态" width="160"></el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template>
          <el-button type="text" size="small">上传</el-button>
          <el-button type="text" size="small">填写物流单号</el-button>
        </template>
      </el-table-column>
    </el-table>

    <add-tracking ref="invoceRef"></add-tracking>
  </div>
</template>

<script>
import api from '@/api/api';
import { applyStatusAll } from '@/utils/enum';
import AddTracking from './components/addTracking';

export default {
  name: 'invoiceApply',
  components: {
    AddTracking,
  },
  data() {
    return {
      applyStatusAll,
      form: {
        enterpriseName: '',
        invoiceApplyStatus: 0,
        time: '',
      },
      data: [],
    };
  },
  methods: {
    submitForm() {},
    resetForm() {
      this.$refs.form.resetFields();
    },
    generateTax() {
      api
        .generatePersonTax()
        .then((res) => {
          if (res === 0) {
            this.$message({
              type: 'success',
              message: '已生成上月完税证明',
            });
          }
          // this.data = res.data;
          // this.count = res.count || 0;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    setAmount() {
      this.$refs.invoceRef.show();
    },
    exportInfo() {},
  },
};
</script>

<style lang="less" scoped>
.person-proof {
  .person-proof-tip {
    padding: 8px 12px;
    border: 1px solid #ffcd61;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fffcf2;
    margin-bottom: 24px;
    > span {
      display: block;
    }
  }
  .person-proof-form {
    border: 1px solid #ebeef5;
    padding: 16px;
    margin-bottom: 16px;
    .form-title {
      font-size: 16px;
      font-weight: 700;
      color: #050505;
      margin-bottom: 20px;
      display: block;
    }
  }
  /deep/ .el-date-editor.el-input {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dutyPaid/personProof.vue